import { render, staticRenderFns } from "./SimplifiedOrderSales.vue?vue&type=template&id=6cd204b7&scoped=true&"
import script from "./SimplifiedOrderSales.vue?vue&type=script&lang=js&"
export * from "./SimplifiedOrderSales.vue?vue&type=script&lang=js&"
import style0 from "./SimplifiedOrderSales.vue?vue&type=style&index=0&id=6cd204b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd204b7",
  null
  
)

export default component.exports